import { Injectable, NgZone } from '@angular/core';

/**
 * Notifiche desktop del browser per i nuovi messaggi chat.
 * Preferenza per-dispositivo in localStorage (default: attiva).
 * Richiede il permesso Notification del browser alla prima attivazione.
 */
@Injectable({
	providedIn: 'root',
})
export class ChatBrowserNotificationService {
	private readonly storageKey = 'chat_browser_notify';

	constructor(private zone: NgZone) {}

	isEnabled(): boolean {
		return localStorage.getItem(this.storageKey) !== 'false';
	}

	setEnabled(enabled: boolean): void {
		localStorage.setItem(this.storageKey, String(enabled));
		if (enabled) {
			this.requestPermission();
		}
	}

	requestPermission(): void {
		if ('Notification' in window && Notification.permission === 'default') {
			Notification.requestPermission();
		}
	}

	/** True se una notifica può effettivamente essere mostrata (preferenza attiva + permesso concesso). */
	canNotify(): boolean {
		return this.isEnabled() && 'Notification' in window && Notification.permission === 'granted';
	}

	/** Mostra la notifica se la preferenza e' attiva e il permesso e' concesso. */
	notify(title: string, body: string, onClick?: () => void): void {
		if (!this.canNotify()) return;
		// Su Chromium Android il costruttore page-scope lancia "Illegal constructor"
		// anche con permesso concesso: intercetta l'errore così non interrompe il
		// chiamante (loop di notifica nel poll header).
		try {
			const n = new Notification(title, { body, icon: 'assets/icons/app/logo/logo_kondor.png' });
			n.onclick = () => {
				window.focus();
				// onclick non è patchato da zone.js: rientra nella zona Angular così
				// la navigazione fa scattare la change detection (pagina non stantia).
				if (onClick) this.zone.run(() => onClick());
				n.close();
			};
		} catch {
			// notifiche non supportate su questa piattaforma: no-op
		}
	}
}
